'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'alien';
var width = 448;
var height = 512;
var aliases = [128125];
var unicode = 'f8f5';
var svgPathData = 'M224 32C118 32 32 118 32 224c0 74.2 47.5 138.1 101.3 186.1c26.3 23.5 52.8 42 72.8 54.6c6.9 4.3 13 8 17.9 10.8c5-2.9 11-6.5 17.9-10.8c19.9-12.6 46.4-31 72.8-54.6C368.5 362.1 416 298.2 416 224c0-106-86-192-192-192zM0 224C0 100.3 100.3 0 224 0S448 100.3 448 224c0 176-224 288-224 288S0 400 0 224zm352 16l-32 0c-26.5 0-48 21.5-48 48l32 0c26.5 0 48-21.5 48-48zm-32-32l32 0 32 0 0 32c0 44.2-35.8 80-80 80l-32 0-32 0 0-32c0-44.2 35.8-80 80-80zM128 240l-32 0c0 26.5 21.5 48 48 48l32 0c0-26.5-21.5-48-48-48zm80 48l0 32-32 0-32 0c-44.2 0-80-35.8-80-80l0-32 32 0 32 0c44.2 0 80 35.8 80 80z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faAlien = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;